/* eslint-disable no-magic-numbers, max-lines */
import defaultRandom from "./random.js"
import deprecations from "./deprecation.js"

function addGridCapabilities (object, config) { //eslint-disable-line complexity
    object.width  = config.width
    object.height = config.height

    setToricProperties(object, config)


    let useArray = setUseArray(object, config)


    if (useArray) {
        object.cells = new Array(object.width * object.height)
    } else {
        object.cells = {}
    }

    initCoordKey(object, useArray)


    deprecations.add("Grid", object, {
        neighboursOf:           "fourNeighborsOf",
        forEachCellWithinRange: "forEachCellInRange",
        forEachCellWithInBox:   "forEachCellInBox",
        clear:                  "deleteAllCells",
        forEachCellWithCoords:  "forEachCell",
        forEachDefinedCellWithCoords: "forEachDefinedCell",
        someCellMatch:          "someCellMatches",
        everyCellMatch:         "everyCellMatches"
    })

    defineIsInside(object)

    //FIXME
    let {random = defaultRandom} = config //eslint-disable-line no-unused-vars



    object.getCell = function (x, y) {
        if (this.isInside(x, y)) {
            return this.cells[this.coordKey(x, y)]
        } else {
            return undefined
        }
    }


    object.getCellFast = function (x, y) {
        return this.cells[this.coordKey(x, y)]
    }


    if (object.width === Infinity && object.height === Infinity) {
        object.getCell = getCellInfinity
    }




    object.getOrCreateCell = function (x, y, defaultValue) {
        if (this.isInside(x, y)) {
            let key  = this.coordKey(x, y)
            let cell = this.cells[key]
            if (!cell) {
                this.cells[key] = defaultValue //here is an update
            }
            return cell || defaultValue
        } else {
            return undefined
        }
    }



    object.deleteCell = function (x, y) {
        this.setCell(x, y, undefined)
    }


    object.deleteCellFast = function (x, y) {
        this.setCellFast(x, y, undefined)
    }




    let implementationDependant = useArray ? arrayMethods : infiniteMethods


    /*for (method in implementationDependant) {
        object[method] = implementationDependant[method]
    }*/

    object.forEachDefinedCellFast = implementationDependant.forEachDefinedCellFast
    object.forEachDefinedCell     = implementationDependant.forEachDefinedCell
    object.setCell                = implementationDependant.setCell
    object.setCellFast            = implementationDependant.setCellFast

    object.everyCellMatches       = implementationDependant.everyCellMatches
    object.someCellMatches        = implementationDependant.someCellMatches
    object.definedCellsCount      = implementationDependant.definedCellsCount
    object.countCellsMatching     = implementationDependant.countCellsMatching

    object.deleteAllCells         = implementationDependant.deleteAllCells


    if (useArray) {
        addUseArraySpecificMethods(object)
    } else {
        addInfiniteSpecificMethods(object)
    }







    object.addCellToSelection = function (x, y, selection) {
        let cell = this.getCell(x, y)
        if (cell !== undefined) {
            selection.push(cell)
        }
        return selection
    }


    object.neighborsOf = function (x, y, {includeDiagonals = false} = {}) {
        if (includeDiagonals) {
            return object.eightNeighborsOf(x, y)
        } else {
            return object.fourNeighborsOf(x, y)
        }
    }


    object.fourNeighborsOf = function (x, y) {
        const result = []
        this.addCellToSelection(x - 1, y,     result)
        this.addCellToSelection(x + 1, y,     result)
        this.addCellToSelection(x,     y - 1, result)
        this.addCellToSelection(x,     y + 1, result)
        return result
    }


    object.eightNeighborsOf = function (x, y) {
        const result = []
        this.addCellToSelection(x - 1, y - 1, result)
        this.addCellToSelection(x,     y - 1, result)
        this.addCellToSelection(x + 1, y - 1, result)
        this.addCellToSelection(x - 1, y,     result)
        this.addCellToSelection(x + 1, y,     result)
        this.addCellToSelection(x - 1, y + 1, result)
        this.addCellToSelection(x,     y + 1, result)
        this.addCellToSelection(x + 1, y + 1, result)
        return result
    }




    object.forEachCellInRange = function ({x, y, range = 0, includeUndefined, iterator}) {
        let xMin = Math.floor(x - range)
        let xMax = Math.floor(x + range)
        let yMin = Math.floor(y - range)
        let yMax = Math.floor(y + range)

        for (let xCell = xMin; xCell <= xMax; xCell++) {
            for (let yCell = yMin; yCell <= yMax; yCell++) {
                let cell = object.getCell(xCell, yCell)
                if (includeUndefined || cell !== undefined) {
                    iterator(cell, xCell, yCell)
                }
            }
        }
    }


    object.forEachCellInBox = function ({xMin, xMax, yMin, yMax, includeUndefined, iterator}) {
        xMin = Math.floor(xMin)
        xMax = Math.floor(xMax)
        yMin = Math.floor(yMin)
        yMax = Math.floor(yMax)

        for (let xCell = xMin; xCell <= xMax; xCell++) {
            for (let yCell = yMin; yCell <= yMax; yCell++) {
                let cell = object.getCell(xCell, yCell)
                if (includeUndefined || cell !== undefined) {
                    iterator(cell, xCell, yCell)
                }
            }
        }
    }



    object.findFirstInSequence = function (params) {
        let results = findInSequence(this, Object.assign({}, params, {limit: 1}))
        if (results.length === 1) {
            return results[0]
        } else {
            return null
        }
    }

    object.findFirstInSequenceWithCoords = function (params) {
        let results = findInSequence(this,  Object.assign({}, params, {limit: 1, withCoords: true}))
        if (results.length > 0) {
            return results[0]
        } else {
            return null
        }
    }

    object.findAllInSequence = function (params) {
        return findInSequence(this, params)
    }

    object.findAllInSequenceWithCoords = function (params) {
        return findInSequence(this,  Object.assign({}, params, {withCoords: true}))
    }


    object.forEachDefinedCellInSequence = function (params) {
        let {iterator} = params
        findInSequence(
            this,
            Object.assign({}, params, {withCoords: true, includeUndefined: false})
        ).forEach(({cell, x, y}) => iterator(cell, x, y))
    }

    object.forEachCellInSequence = function (params) {
        let {iterator} = params
        findInSequence(
            this,
            Object.assign({}, params, {withCoords: true, includeUndefined: true})
        ).forEach(({cell, x, y}) => iterator(cell, x, y))
    }



    object.findCellsConnectedTo = function ({ //eslint-disable-line complexity
        x: startX, y: startY,
        filter,
        maxPathLength = Infinity,
        includeUndefined,
        withCoords, includeDiagonals
    }) {
        if (!object.isInside(startX, startY)) {
            return []
        }
        let startCell = object.getCell(startX, startY)
        if (
            (startCell === undefined && !includeUndefined) ||
            !filter(startCell, startX, startY)
        ) {
            return []
        }

        let keys = {}
        keys[object.coordKey(startX, startY)] = true
        let additions = [{cell: startCell, x: startX, y: startY}]
        let results   = [additions[0]]

        let pathLength = 0

        let connected = includeDiagonals ? connectedEight : connectedFour


        function isNotAlreadySelected ({x, y}) {
            let key = object.coordKey(x, y)
            if (key in keys) {
                return false
            } else {
                keys[key] = true
                return true
            }
        }

        function findConnected ({x, y}) {
            return connected(object, {x, y, filter, includeUndefined}).filter(isNotAlreadySelected)
        }

        while (additions.length > 0 && pathLength < maxPathLength) {
            let oldAdditions = additions
            pathLength += 1
            additions = oldAdditions.map(findConnected).flat()
            results.push(...additions)
        }

        if (withCoords) {
            return results
        } else {
            return results.map(({cell}) => cell)
        }
    }


    object.forEachDefinedCellConnectedTo = function (params) {
        let {iterator} = params
        object.findCellsConnectedTo(
            Object.assign({}, params, {withCoords: true, includeUndefined: false})
        ).forEach(({cell, x, y}) => iterator(cell, x, y))
    }


    object.forEachCellConnectedTo = function (params) {
        let {iterator} = params
        object.findCellsConnectedTo(
            Object.assign({}, params, {withCoords: true, includeUndefined: true})
        ).forEach(({cell, x, y}) => iterator(cell, x, y))
    }


    //FIXME - specs

    object.import = function (params, {cellImporter, clear = true} = {}) {

        if (clear) {
            object.deleteAllCells()
        }

        importGlobalConfig(params)

        cellImporter = cellImporter || object.cellImporter

        const {cells} = params

        for (let key in cells) {
            let [x, y] = key.split("_")
            x = parseInt(x, 10)
            y = parseInt(y, 10)
            let cell = cells[key]

            if (object.importCell) {
                object.importCell(cell, x, y)
                continue
            }
            if (cellImporter) {
                cell = cellImporter(cell, x, y)
            }
            object.setCell(x, y, cell)
        }
    }


    //FIXME - specs

    function importGlobalConfig ({width, height, toricX, toricY}) {
        if (width !== undefined) {
            object.width = width
        }
        if (height !== undefined) {
            object.height = height
        }

        if (toricX !== undefined) {
            object.toricX = toricX
        }
        if (toricY !== undefined) {
            object.toricY = toricY
        }
    }


    object.serialize = function ({cellSerializer} = {}) {
        const cells = {}
        this.forEachDefinedCell((cell, x, y) => {
            const key = `${x}_${y}`
            if (cellSerializer) {
                cells[key] = cellSerializer(cell, x, y)
            } else if (cell && typeof cell === "object" && cell.serialize) {
                cells[key] = cell.serialize()
            } else {
                cells[key] = cell
            }
        })

        const {width, height, toricX, toricY} = this
        return {width, height, toricX, toricY, cells}
    }


    object.clone = function () {
        const cloned = {}
        addGridCapabilities(cloned, this)

        this.forEachDefinedCell((cell, x, y) => {
            cloned.setCell(x, y, cell)
        })

        return cloned
    }


    object.transpose = function () {

        let old = partialClone(this)

        switchXYDimensions(object)
        this.deleteAllCells()

        old.forEachDefinedCell((cell, x, y) => {
            this.setCell(y, x, cell)
        })
    }


    object.flip = function (direction = "horizontal") {

        let old = partialClone(this)
        this.deleteAllCells()

        if (direction === "horizontal") {
            let {width} = this
            if (width === Infinity) {
                old.forEachDefinedCell((cell, x, y) => {
                    this.setCell(-x, y, cell)
                })
            } else {
                old.forEachDefinedCell((cell, x, y) => {
                    this.setCell(width - x - 1, y, cell)
                })
            }
        } else {
            let {height} = this
            if (height === Infinity) {
                old.forEachDefinedCell((cell, x, y) => {
                    this.setCell(x, -y, cell)
                })
            } else {
                old.forEachDefinedCell((cell, x, y) => {
                    this.setCell(x, height - y - 1, cell)
                })
            }
        }

    }


    object.rotate = function (angle = 90) { //eslint-disable-line complexity

        angle = (angle + 720) % 360
        if (angle === 0) {
            return
        }

        let old = partialClone(this)

        if (angle === 90 || angle === 270) {
            switchXYDimensions(this)
        }

        this.deleteAllCells()

        let newX
        let newY

        let {width, height} = this

        if (angle === 90) {
            if (width === Infinity) {
                newX = (x, y) => -y
            } else {
                newX = (x, y) => width - y - 1
            }
            newY = (x) => x
        } else if (angle === 180) {
            if (width === Infinity) {
                newX = (x) => -x
            } else {
                newX = (x) => width - x - 1
            }
            if (height === Infinity) {
                newY = (x, y) => -y
            } else {
                newY = (x, y) => height - y - 1
            }
        } else if (angle === 270) {
            if (height === Infinity) {
                newY = (x) => -x
            } else {
                newY = (x) => height - x - 1
            }
            newX = (x, y) => y
        }


        old.forEachDefinedCell((cell, x, y) => {
            this.setCell(newX(x, y), newY(x, y), cell)
        })

    }


    if (config.content) {
        object.setCells(config.content)
    }

}



function switchXYDimensions (object) {
    let w = object.width
    object.width  = object.height
    object.height = w

    let t = object.toricX
    object.toricX = object.toricY
    object.toricY = t

    if (t || object.toricX) {
        initCoordKey(object, Array.isArray(object.cells))
    }
    defineIsInside(object)

}


function partialClone (object) {
    let {cells, coordKey, width, height, forEachDefinedCell} = object
    let result = {cells, coordKey, width, height, forEachDefinedCell}
    if (object.toricX || object.toricY) {
        initCoordKey(result, Array.isArray(cells))
    }
    return result
}




function setUseArray (object, params) {
    return (object.width !== Infinity && object.height !== Infinity) && !params.dontUseArray
}


function setToricProperties (object, {toric, toricX, toricY}) {
    object.toric  = toric
    object.toricX = toric || toricX
    object.toricY = toric || toricY
}


function alwaysTrue () {
    return true
}


function getCellInfinity (x, y) {
    return this.cells[`${x}_${y}`]
}


function initCoordKey (object, useArray) { //eslint-disable-line complexity

    if (useArray) {
        object.nonToricCoordKey = function (x, y) {
            return x + this.width * y
        }
    } else {
        object.nonToricCoordKey = function (x, y) {
            return `${x}_${y}`
        }
    }


    function toricCoordKeyArray (x, y) {
        return toricX(x) + this.width * toricY(y)
    }

    function toricCoordKeyNoArray (x, y) {
        return `${toricX(x)}_${toricY(y)}`
    }

    function toricXCoordKeyArray (x, y) {
        return toricX(x) + this.width * y
    }

    function toricXCoordKeyNoArray (x, y) {
        return `${toricX(x)}_${y}`
    }

    function toricYCoordKeyArray (x, y) {
        return x + this.width * toricY(y)
    }

    function toricYCoordKeyNoArray (x, y) {
        return `${x}_${toricY(y)}`
    }


    if (object.toric) {
        if (useArray) {
            object.coordKey = toricCoordKeyArray
        } else {
            object.coordKey = toricCoordKeyNoArray
        }
    } else if (object.toricX) {
        if (useArray) {
            object.coordKey = toricXCoordKeyArray
        } else {
            object.coordKey = toricXCoordKeyNoArray
        }
    } else if (object.toricY) {
        if (useArray) {
            object.coordKey = toricYCoordKeyArray
        } else {
            object.coordKey = toricYCoordKeyNoArray
        }
    } else {
        object.coordKey = object.nonToricCoordKey
    }


    if (object.toric || object.toricX) {
        object.toricCoordX = toricX
    }

    if (object.toric || object.toricY) {
        object.toricCoordY = toricY
    }


    function toricX (x) {
        return modulo(x, object.width)
    }


    function toricY (y) {
        return modulo(y, object.height)
    }

}


function modulo (n, m) {
    return ((n % m) + m) % m
}




function defineIsInside (object) { //eslint-disable-line complexity

    let freeWidth  = (object.width  === Infinity || object.toricX)
    let freeHeight = (object.height === Infinity || object.toricY)

    if (freeWidth && freeHeight) {
        object.isInside = alwaysTrue
    } else if (freeWidth) {
        object.isInside = isInsideFreeWidth
    } else if (freeHeight) {
        object.isInside = isInsideFreeHeight
    } else {
        object.isInside = isInside
    }

}


function isInside (x, y) {
    return (x >= 0 && y >= 0 && x < this.width && y < this.height)
}

function isInsideFreeWidth (x, y) {
    return (y >= 0 && y < this.height)
}

function isInsideFreeHeight (x) {
    return (x >= 0 && x < this.width)
}






const arrayMethods    = {}
const infiniteMethods = {}


arrayMethods.setCell = function (x, y, value) {   //here is an update
    if (this.isInside(x, y)) {
        this.cells[this.coordKey(x, y)] = value
        return true
    } else {
        return false
    }
}

arrayMethods.setCellFast = function (x, y, value) {   //here is an update
    this.cells[this.coordKey(x, y)] = value
}


infiniteMethods.setCell = function (x, y, value) {
    if (this.isInside(x, y)) {
        return this.setCellInfinity(x, y, value)
    } else {
        return false
    }
}


infiniteMethods.setCellFast = function (x, y, value) {
    this.setCellInfinity(x, y, value)
}





arrayMethods.forEachDefinedCellFast = function (iterator) {
    for (let i = 0; i < this.cells.length; i++) {
        if (this.cells[i] !== undefined) {
            iterator(this.cells[i])
        }
    }
}

infiniteMethods.forEachDefinedCellFast = function (iterator) {
    for (let key in this.cells) {
        iterator(this.cells[key])
    }
}





arrayMethods.forEachDefinedCell = function (iterator) {
    for (let x = 0; x < this.width; x++) {
        for (let y = 0; y < this.height; y++) {
            let cell = this.cells[this.coordKey(x, y)]
            if (cell !== undefined) {
                iterator(cell, x, y)
            }
        }
    }
}

infiniteMethods.forEachDefinedCell = function (iterator) {
    for (let key in this.cells) {
        let coords = key.split("_")
        iterator(this.cells[key], parseInt(coords[0], 10), parseInt(coords[1], 10))
    }
}




arrayMethods.definedCellsCount = function () {
    let count = 0
    for (let i = 0; i < this.cells.length; i++) {
        if (this.cells[i] !== undefined) {
            count++
        }
    }
    return count
}

infiniteMethods.definedCellsCount = function () {
    return Object.keys(this.cells).length
}






// the test functions of someCellMatches / everyCellMatches / countCellsMatching all
// receive (value, x, y), like forEachCell — one signature for the whole family
arrayMethods.someCellMatches = function (testFunction) {
    for (let x = 0; x < this.width; x++) {
        for (let y = 0; y < this.height; y++) {
            if (testFunction(this.cells[this.coordKey(x, y)], x, y)) {
                return true
            }
        }
    }

    return false
}

infiniteMethods.someCellMatches = function (testFunction) {
    for (let key in this.cells) {
        let coords = key.split("_")
        if (testFunction(this.cells[key], parseInt(coords[0], 10), parseInt(coords[1], 10))) {
            return true
        }
    }

    return false
}





arrayMethods.everyCellMatches = function (testFunction) {
    for (let x = 0; x < this.width; x++) {
        for (let y = 0; y < this.height; y++) {
            if (!testFunction(this.cells[this.coordKey(x, y)], x, y)) {
                return false
            }
        }
    }

    return true
}

infiniteMethods.everyCellMatches = function (testFunction) {
    for (let key in this.cells) {
        let coords = key.split("_")
        if (!testFunction(this.cells[key], parseInt(coords[0], 10), parseInt(coords[1], 10))) {
            return false
        }
    }

    return true
}






arrayMethods.countCellsMatching = function (testFunction) {
    let count = 0
    for (let x = 0; x < this.width; x++) {
        for (let y = 0; y < this.height; y++) {
            if (testFunction(this.cells[this.coordKey(x, y)], x, y)) {
                count += 1
            }
        }
    }

    return count
}

infiniteMethods.countCellsMatching = function (testFunction) {
    let count = 0
    for (let key in this.cells) {
        let coords = key.split("_")
        if (testFunction(this.cells[key], parseInt(coords[0], 10), parseInt(coords[1], 10))) {
            count += 1
        }
    }

    return count
}



arrayMethods.deleteAllCells = function () {
    this.cells = new Array(this.width * this.height)    //here is an update
}


infiniteMethods.deleteAllCells = function () {          //here is an update
    this.cells = {}
}




function findInSequence ( //eslint-disable-line complexity
    object,
    {
        x: xOrigin, y: yOrigin,
        step, range = false, limit = false,
        filter,
        stopOnMismatch = false,
        includeStart = true, includeUndefined = false,
        withCoords = false
    }
) {

    if (!step) {
        throw new Error("Step is not defined")
    }

    const results = []
    const {x: stepX = 0, y: stepY = 0} = step

    range = resolveRange(object, {xOrigin, yOrigin, stepX, stepY, range, limit})


    const start = (includeStart ? 0 : 1)
    for (let i = start; i <= range; i++) {
        const stepXCoord = xOrigin + i * stepX
        const stepYCoord = yOrigin + i * stepY
        if (!object.isInside(stepXCoord, stepYCoord)) {
            continue
        }
        const {x, y} = normalizedCoords(object, stepXCoord, stepYCoord)
        const cell = object.getCell(x, y)
        if ((cell !== undefined || includeUndefined) && (!filter || filter(cell, x, y))) {
            const result = withCoords ? {cell, x, y} : cell
            results.push(result)
            if (results.length === limit) {
                return results
            }
        } else if (stopOnMismatch) {
            break
        }
    }
    return results
}



function connectedFour (object, {x, y, filter, includeUndefined}) {
    let results = []
    forEachFourNeighborsCoords(x, y, (nx, ny) => {
        addCellToSelection(object, results, {x: nx, y: ny, filter, includeUndefined})
    })
    return results
}

function connectedEight (object, {x, y, filter, includeUndefined}) {
    let results = []
    forEachEightNeighborsCoords(x, y, (nx, ny) => {
        addCellToSelection(object, results, {x: nx, y: ny, filter, includeUndefined})
    })
    return results
}


function addCellToSelection (object, selection, {x, y, filter, includeUndefined}) {
    if (!object.isInside(x, y)) {
        return
    }
    let cell = object.getCell(x, y)
    if (
        (includeUndefined || cell !== undefined) &&
        filter(cell, x, y)
    ) {
        selection.push({cell, ...normalizedCoords(object, x, y)})
    }
}


function normalizedCoords (object, x, y) {
    return {
        x: object.toricCoordX ? object.toricCoordX(x) : x,
        y: object.toricCoordY ? object.toricCoordY(y) : y
    }
}



function resolveRange (object, {xOrigin, yOrigin, stepX, stepY, range, limit}) { //eslint-disable-line complexity

    if (range !== false) {
        return range
    }

    if (limit === false) {
        let xError = (stepX !== 0 && (object.toricX || object.width === Infinity))

        if (stepY !== 0 && (object.toricY || object.height === Infinity)) {
            if (xError) {
                throw new Error("Range or limit must be specified")
            }
            throw new Error("Range or limit must be specified to search in the y direction")
        }

        if (xError) {
            throw new Error("Range or limit must be specified to search in the x direction")
        }
    }


    if (stepX > 0) {
        range = Math.floor((object.width - 1 - xOrigin) / stepX)
    } else if (stepX < 0) {
        range = Math.floor(xOrigin / -stepX)
    } else {
        range = Infinity
    }


    if (stepY > 0) {
        range = Math.min(range, Math.floor((object.height - 1 - yOrigin) / stepY))
    } else if (stepY < 0) {
        range = Math.min(range, Math.floor(yOrigin / -stepY))
    } else if (stepX === 0) {
        throw new Error("Step can not be x: 0 and y: 0")
    }

    return range


}




function forEachFourNeighborsCoords (x, y, iterator) {
    iterator(x - 1, y)
    iterator(x + 1, y)
    iterator(x,     y - 1)
    iterator(x,     y + 1)
}


function forEachEightNeighborsCoords (x, y, iterator) {
    iterator(x - 1, y - 1)
    iterator(x,     y - 1)
    iterator(x + 1, y - 1)
    iterator(x - 1, y)
    iterator(x + 1, y)
    iterator(x - 1, y + 1)
    iterator(x,     y + 1)
    iterator(x + 1, y + 1)
}









function addUseArraySpecificMethods (object) {

    object.forEachCellFast = function (iterator) {
        for (let i = 0; i < this.cells.length; i++) {
            iterator(this.cells[i])
        }
    }

    object.forEachCell = function (iterator) {
        for (let x = 0; x < this.width; x++) {
            for (let y = 0; y < this.height; y++) {
                iterator(this.cells[this.coordKey(x, y)], x, y)
            }
        }
    }


    object.setCells = function (value) {      //here is an update
        let {cells} = this
        this.forEachCell(function (cell, x, y) {
            if (typeof value === "function") {
                cells[object.coordKey(x, y)] = value(x, y)
            } else {
                cells[object.coordKey(x, y)] = value
            }
        })
    }

}





function addInfiniteSpecificMethods (object) {


    //consider private
    object.setCellInfinity = function (x, y, value) {     //here is an update
        if (typeof value === "undefined") {
            delete this.cells[this.coordKey(x, y)]
        } else {
            this.cells[this.coordKey(x, y)] = value
        }
        return true
    }


    if (object.width === Infinity && object.height === Infinity) {
        object.setCell = object.setCellInfinity
    }

}







export default addGridCapabilities

